if (!customElements.get("upsell-carousel")) {
  customElements.define(
    "upsell-carousel",
    class UpsellCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector("[data-upsell-track]");
        this.cards = Array.from(
          this.querySelectorAll(".wt-product__upsell__card"),
        );
        this.previousButton = this.closest(".wt-product__upsell--bundle")?.querySelector(
          "[data-upsell-previous]",
        );
        this.nextButton = this.closest(".wt-product__upsell--bundle")?.querySelector(
          "[data-upsell-next]",
        );
        this.currentLabel = this.closest(".wt-product__upsell--bundle")?.querySelector(
          "[data-upsell-current]",
        );
        this.dots = Array.from(this.querySelectorAll("[data-upsell-dot]"));
        this.currentIndex = 0;
        this.frame = null;

        if (!this.track || this.cards.length < 2) return;

        this.previousButton?.addEventListener("click", () => {
          this.goTo(Math.max(0, this.currentIndex - 1));
        });
        this.nextButton?.addEventListener("click", () => {
          this.goTo(Math.min(this.cards.length - 1, this.currentIndex + 1));
        });
        this.dots.forEach((dot, index) => {
          dot.addEventListener("click", () => this.goTo(index));
        });
        this.track.addEventListener("scroll", () => this.onScroll(), {
          passive: true,
        });
        this.track.addEventListener("keydown", (event) => {
          if (event.key === "ArrowLeft") {
            event.preventDefault();
            this.goTo(Math.max(0, this.currentIndex - 1));
          }
          if (event.key === "ArrowRight") {
            event.preventDefault();
            this.goTo(Math.min(this.cards.length - 1, this.currentIndex + 1));
          }
        });

        this.update(0);
      }

      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      goTo(index) {
        const card = this.cards[index];
        if (!card) return;
        this.track.scrollTo({
          left: card.offsetLeft - this.cards[0].offsetLeft,
          behavior: "smooth",
        });
      }

      onScroll() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const trackLeft = this.track.getBoundingClientRect().left;
          let closestIndex = 0;
          let closestDistance = Infinity;

          this.cards.forEach((card, index) => {
            const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          this.update(closestIndex);
        });
      }

      update(index) {
        this.currentIndex = index;
        if (this.currentLabel) this.currentLabel.textContent = String(index + 1);
        if (this.previousButton) this.previousButton.disabled = index === 0;
        if (this.nextButton) {
          this.nextButton.disabled = index === this.cards.length - 1;
        }
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle("is-active", active);
          dot.setAttribute("aria-selected", String(active));
        });
      }
    },
  );
}
